import { useMutation, useQuery } from '@tanstack/react-query';

import competencyCatalogService, {
    type ImportCompetenciesPayload,
} from './competencyCatalogService';

import type { CompetencyGroup } from '@/types/competency/Competency';

import { queryClient } from '@/AppWithProviders';
import { CompetencyCatalogQueryKey, CompetencyQueryKey } from '@/constants/QueryKeys';

const useGetCompetencyCatalog = (enabled = true) => {
    return useQuery<CompetencyGroup[]>({
        queryKey: [CompetencyCatalogQueryKey.COMPETENCY_CATALOG],
        queryFn: () => competencyCatalogService.getCompetencyCatalog(),
        enabled,
    });
};

const useImportCompetencies = () => {
    return useMutation({
        mutationFn: (payload: ImportCompetenciesPayload) =>
            competencyCatalogService.importCompetencies(payload),
        onSuccess: () => {
            queryClient.invalidateQueries({
                queryKey: [CompetencyQueryKey.COMPETENCY_GROUPS],
            });
        },
    });
};

export { useGetCompetencyCatalog, useImportCompetencies };
